import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const TermsOfService = () => {
  return (
    <Container fluid className="py-5" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={12}>
            <Card className="shadow-sm">
              <Card.Header 
                className="text-center py-4"
                style={{ 
                  background: 'linear-gradient(135deg, #2457c5 0%, #779ee5 100%)',
                  color: 'white',
                  border: 'none'
                }}
              >
                <h1 className="mb-2 fw-bold">Terms of Service</h1>
                <p className="mb-0">Innovatix Technology Partners</p>
                <small>Last updated: 11/12/2025</small>
              </Card.Header>
              
              <Card.Body className="p-4">
                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>1. Acceptance of Terms</h2>
                  <p className="text-muted">
                    By accessing and using the Innovatix AI-powered QA automation platform ("Service"), 
                    you accept and agree to be bound by the terms and provision of this agreement. 
                    If you do not agree to abide by the above, please do not use this service.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>2. Description of Service</h2>
                  <p className="text-muted mb-3">
                    Innovatix Technology Partners provides AI-powered quality assurance automation services, including:
                  </p>
                  <ul className="text-muted mb-3">
                    <li>Business Requirements Document (BRD) to Functional Requirements Document (FRD) conversion</li>
                    <li>Automated test case generation from functional specifications</li>
                    <li>Test automation script generation using various frameworks (Selenium, Cypress, Playwright, etc.)</li>
                    <li>Comprehensive bug report generation and analysis</li>
                    <li>API test automation with RestAssured framework</li>
                    <li>Test data factory for realistic data generation</li>
                    <li>AI design generator for responsive HTML creation</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>3. User Accounts and Registration</h2>
                  <p className="text-muted mb-3">
                    To access certain features of our Service, you must register for an account. You agree to:
                  </p>
                  <ul className="text-muted mb-3">
                    <li>Provide accurate, current, and complete information during registration</li>
                    <li>Maintain and update your account information to keep it accurate and current</li>
                    <li>Maintain the security of your password and account</li>
                    <li>Accept responsibility for all activities under your account</li>
                    <li>Notify us immediately of any unauthorized use of your account</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>4. Acceptable Use Policy</h2>
                  <p className="text-muted mb-3">You agree to use our Service only for lawful purposes and in accordance with these Terms. You agree NOT to:</p>
                  <ul className="text-muted mb-3">
                    <li>Upload, transmit, or distribute any content that is illegal, harmful, or violates any rights</li>
                    <li>Attempt to gain unauthorized access to our systems or other users' accounts</li>
                    <li>Use the Service for any commercial purpose without our express written consent</li>
                    <li>Reverse engineer, decompile, or disassemble any part of our Service</li>
                    <li>Interfere with or disrupt the Service or servers connected to the Service</li>
                    <li>Use automated systems to access the Service without permission</li>
                    <li>Upload malicious code, viruses, or other harmful content</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>5. Intellectual Property Rights</h2>
                  
                  <h5 className="h6 fw-bold mb-2" style={{ color: '#fb8b24' }}>5.1 Our Intellectual Property</h5>
                  <p className="text-muted mb-3">
                    The Service and its original content, features, and functionality are owned by Innovatix Technology Partners 
                    and are protected by international copyright, trademark, patent, trade secret, and other intellectual 
                    property laws.
                  </p>

                  <h5 className="h6 fw-bold mb-2" style={{ color: '#fb8b24' }}>5.2 Your Content</h5>
                  <p className="text-muted mb-3">
                    You retain ownership of any content you upload or generate using our Service. By using our Service, 
                    you grant us a limited, non-exclusive, royalty-free license to use, process, and store your content 
                    solely for the purpose of providing our services to you.
                  </p>

                  <h5 className="h6 fw-bold mb-2" style={{ color: '#fb8b24' }}>5.3 Generated Content</h5>
                  <p className="text-muted mb-3">
                    Content generated by our AI systems (test cases, scripts, reports, etc.) is provided to you for 
                    your use. You are responsible for reviewing and validating all generated content before use in 
                    production environments.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>6. Privacy and Data Protection</h2>
                  <p className="text-muted mb-3">
                    Your privacy is important to us. Our collection and use of personal information is governed by 
                    our Privacy Policy, which is incorporated into these Terms by reference. By using our Service, 
                    you consent to the collection and use of information as described in our Privacy Policy.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>7. Service Availability</h2>
                  <p className="text-muted mb-3">
                    We strive to provide continuous service availability, but we do not guarantee that our Service 
                    will be uninterrupted or error-free. We reserve the right to modify, suspend, or discontinue 
                    the Service at any time with or without notice.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>8. Disclaimers and Limitations</h2>
                  
                  <h5 className="h6 fw-bold mb-2" style={{ color: '#fb8b24' }}>8.1 Service Disclaimer</h5>
                  <p className="text-muted mb-3">
                    Our Service is provided "as is" and "as available" without warranties of any kind, either express 
                    or implied. We disclaim all warranties, including but not limited to merchantability, fitness for 
                    a particular purpose, and non-infringement.
                  </p>

                  <h5 className="h6 fw-bold mb-2" style={{ color: '#fb8b24' }}>8.2 AI-Generated Content</h5>
                  <p className="text-muted mb-3">
                    AI-generated content is provided for informational purposes only. You are responsible for reviewing, 
                    validating, and testing all generated content before use. We do not guarantee the accuracy, 
                    completeness, or suitability of AI-generated content for your specific needs.
                  </p>

                  <h5 className="h6 fw-bold mb-2" style={{ color: '#fb8b24' }}>8.3 Limitation of Liability</h5>
                  <p className="text-muted mb-3">
                    To the maximum extent permitted by law, Innovatix Technology Partners shall not be liable for any 
                    indirect, incidental, special, consequential, or punitive damages, including but not limited to 
                    loss of profits, data, or use, arising from your use of our Service.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>9. Indemnification</h2>
                  <p className="text-muted mb-3">
                    You agree to indemnify and hold harmless Innovatix Technology Partners, its officers, directors, 
                    employees, and agents from any claims, damages, losses, or expenses (including reasonable attorneys' 
                    fees) arising from your use of our Service or violation of these Terms.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>10. Termination</h2>
                  <p className="text-muted mb-3">
                    We may terminate or suspend your account and access to our Service immediately, without prior notice 
                    or liability, for any reason whatsoever, including without limitation if you breach these Terms. 
                    Upon termination, your right to use the Service will cease immediately.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>11. Governing Law</h2>
                  <p className="text-muted mb-3">
                    These Terms shall be governed by and construed in accordance with the laws of the State of New Jersey, 
                    without regard to its conflict of law provisions. Any disputes arising from these Terms or your use 
                    of our Service shall be subject to the exclusive jurisdiction of the courts in New Jersey.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>12. Changes to Terms</h2>
                  <p className="text-muted mb-3">
                    We reserve the right to modify these Terms at any time. We will notify users of any material changes 
                    by posting the new Terms on this page and updating the "Last updated" date. Your continued use of 
                    our Service after such changes constitutes acceptance of the updated Terms.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>13. Severability</h2>
                  <p className="text-muted mb-3">
                    If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions 
                    will remain in full force and effect. The invalid provision will be replaced with a valid provision 
                    that most closely approximates the intent of the original provision.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>14. Contact Information</h2>
                  <p className="text-muted mb-3">
                    If you have any questions about these Terms of Service, please contact us:
                  </p>
                  <div className="bg-light p-3 rounded">
                    <p className="mb-1"><strong>Innovatix Technology Partners</strong></p>
                    <p className="mb-1">135 Route 202/206, Suite 9</p>
                    <p className="mb-1">Bedminster, NJ 07921</p>
                    <p className="mb-1">Phone: 973-889-0500 Ext 1</p>
                    <p className="mb-0">Email: legal@innovatixinc.com</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default TermsOfService;